import { render, staticRenderFns } from "./SpamMx.vue?vue&type=template&id=1d42d091&scoped=true"
import script from "./SpamMx.vue?vue&type=script&lang=js"
export * from "./SpamMx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d42d091",
  null
  
)

export default component.exports